import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Seo({
  title,
  description,
  canonical,
  noindex,
  ogImage,
  ogImageAlt = 'Sovrynn',
}) {
  return (
    <Helmet defer={false} prioritizeSeoTags>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {noindex ? <meta name="robots" content="noindex" /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sovrynn" />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      {ogImage ? <meta property="og:image:width" content="1200" /> : null}
      {ogImage ? <meta property="og:image:height" content="630" /> : null}
      {ogImage ? <meta property="og:image:alt" content={ogImageAlt} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}
    </Helmet>
  );
}
